import { render, staticRenderFns } from "./OnboardingNotionModal.vue?vue&type=template&id=d34201ca&scoped=true&"
import script from "./OnboardingNotionModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingNotionModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingNotionModal.vue?vue&type=style&index=0&id=d34201ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34201ca",
  null
  
)

export default component.exports